export default __webpack_public_path__ + "static/media/category2.f55a9414.png";